module.exports = __webpack_public_path__ + "static/EuclidTriangle-Semibold-WebS-387b14540d8a6d2226c7d008bd84f3e0.woff2";